import { render } from "./baseModalMozaic.vue?vue&type=template&id=5f561507&scoped=true"
import script from "./baseModalMozaic.vue?vue&type=script&lang=js"
export * from "./baseModalMozaic.vue?vue&type=script&lang=js"

import "./baseModalMozaic.vue?vue&type=style&index=0&id=5f561507&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f561507"]])

export default __exports__